<template>
  <div class="teaching-evaluate-apply-define-main-config"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="configInfo">
      <div class="main"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="main-cont">
          <AppScrollbar style="height: 100%">
            <div class="config-main">
              <DataGrid size="mini"
                        border="none"
                        :data="configInfo.evaluationDefines">
                <DataGridColumn type="seq"
                                title=" "
                                width="40px"
                                align="right"></DataGridColumn>
                <DataGridColumn title="评教内容（最多填写100字）">
                  <template #default="{row}">
                    <el-input v-model="row.title"
                              size="mini"
                              type="text"
                              maxlength="100"
                              show-word-limit
                              placeholder="填写评教内容"></el-input>
                  </template>
                </DataGridColumn>
                <DataGridColumn title="是否直接输入分数"
                                width="150px"
                                align="center">
                  <template #default="{row}">
                    <el-select v-model="row.inputMode"
                               size="mini">
                      <el-option value="0" label="否"></el-option>
                      <el-option value="1" label="是"></el-option>
                    </el-select>
                  </template>
                </DataGridColumn>
                <DataGridColumn title="操作"
                                width="120px"
                                align="center">
                  <template #default="{row}">
                    <el-button size="mini"
                               type="text"
                               @click="insertItem(row)">插入</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <el-button size="mini"
                               type="text"
                               @click="deleteItem(row)">删除</el-button>
                  </template>
                </DataGridColumn>
                <template #empty>
                  <span class="empty-tip">未设置评教内容</span>
                </template>
              </DataGrid>
              <div class="append">
                <el-button size="mini"
                           type="text"
                           icon="el-icon-circle-plus"
                           :disabled="committing"
                           @click="addItem">添加评教内容</el-button>
              </div>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">确认设置</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>评教内容数据加载失败</div>
        <el-button type="text"
                   @click="loadConfigInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../elements/AppScrollbar'
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'TeachingEvaluateApplyDefineMainConfig',
  components: {
    AppScrollbar,
    DataGrid,
    DataGridColumn,
    Hint
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    },
    defineSetup: {
      type: Object,
      required: true
    },
    defineQuota: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      configInfo: null,
      committing: false
    }
  },
  methods: {
    loadConfigInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/define/configInfo',
        method: 'post',
        data: this.$qs.stringify({
          id: this.evaluation.id,
          courseId: this.defineSetup.id,
          quotaId: this.defineQuota.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.configInfo = response.data['configInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    addItem () {
      let configInfo = this.configInfo
      if (configInfo) {
        let evaluationDefines = configInfo.evaluationDefines || []
        evaluationDefines.push({
          inputMode: '0'
        })
        this.$set(configInfo, 'evaluationDefines', evaluationDefines)
      }
    },
    insertItem (item) {
      let configInfo = this.configInfo
      if (configInfo) {
        let evaluationDefines = configInfo.evaluationDefines || []
        if (evaluationDefines) {
          let index = evaluationDefines.indexOf(item)
          if (index >= 0) {
            evaluationDefines.splice(index, 0, {
              inputMode: '0'
            })
          }
        }
      }
    },
    deleteItem (item) {
      let configInfo = this.configInfo
      if (configInfo) {
        let evaluationDefines = configInfo.evaluationDefines
        if (evaluationDefines) {
          let index = evaluationDefines.indexOf(item)
          if (index >= 0) {
            evaluationDefines.splice(index, 1)
          }
        }
      }
    },
    handleApply () {
      let configInfo = this.configInfo
      if (configInfo) {
        let evaluationDefines = configInfo.evaluationDefines || []
        let isValid = evaluationDefines.every((item, index) => {
          if (!item.title) {
            this.$message.warning(`第${index + 1}项评教内容不能为空`)
            return
          }
          if (!item.inputMode) {
            this.$message.warning(`请选择第${index + 1}项评教打分方式`)
            return
          }
          return true
        })
        if (!isValid) {
          return
        }
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/teaching/evaluate/apply/define/submitConfigInfo',
          method: 'post',
          data: this.$qs.stringify({
            id: this.evaluation.id,
            courseId: this.defineSetup.id,
            quotaId: this.defineQuota.id,
            configInfo: JSON.stringify({
              items: evaluationDefines
            })
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  let evaluationDefines = response.data['evaluationDefines']
                  if (evaluationDefines) {
                    this.$set(configInfo, 'evaluationDefines', evaluationDefines)
                  }
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }
    }
  },
  mounted () {
    this.loadConfigInfo()
  }
}
</script>

<style lang="scss">
  .teaching-evaluate-apply-define-main-config {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 5px;
    box-sizing: border-box;
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .config-main {
          .vxe-table {
            .vxe-table--header-wrapper {
              .vxe-table--header {
                .vxe-header--row {
                  .vxe-header--column {
                    height: 46px;
                    padding: 0;
                  }
                }
              }
            }
            .vxe-table--body-wrapper {
              .vxe-table--body {
                .vxe-body--row {
                  .vxe-body--column {
                    position: relative;
                    height: 46px;
                    padding: 0;
                    .vxe-cell {
                      .el-input,
                      .el-select {
                        width: 100%;
                      }
                    }
                  }
                }
              }
            }
            .vxe-table--empty-placeholder {
              background-color: #fcfcfc;
              .empty-tip {
                font-size: 12px;
              }
            }
          }
          .append {
            padding: 10px 40px;
          }
        }
      }
    }
    & > .footer {
      flex: none;
      position: relative;
      text-align: center;
      padding: 9px 12px;
      background-color: #f9f9fa;
    }
  }
</style>
